var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Container } from '../services/di';
import { renderDynamicComponent } from '../render';
var DynamicForeach = /** @class */ (function (_super) {
    __extends(DynamicForeach, _super);
    function DynamicForeach(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = {
            items: []
        };
        return _this;
    }
    DynamicForeach.prototype.componentDidMount = function () {
        this.refreshItems();
    };
    DynamicForeach.prototype.refreshItems = function () {
        this.setState({
            items: this.props.dataState.get(this.props.control.path)
        });
    };
    DynamicForeach.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null, this.state.items
            .map(function (item, index) {
            var dataState = Container.createDataStateService();
            dataState.setRecord(item);
            return React.createElement("div", { key: index }, _this.props.control.children
                .map(function (child, index) { return renderDynamicComponent(index, child, dataState); }));
        }));
    };
    return DynamicForeach;
}(React.Component));
export default DynamicForeach;
//# sourceMappingURL=Foreach.js.map